export default __webpack_public_path__ + "static/89-6f329ecab86411cc3bf9ccb61f93d2dc.gif";